/**
 * Static access to the default theme.
 *
 * Kept because a handful of places legitimately need colours outside a React
 * render — the web shell's CSS variables, for instance. Anything inside a
 * component should use `useTheme()` or `makeStyles()` instead, or it will not
 * follow the user's chosen theme.
 */
import { Platform } from 'react-native';
import { THEMES, DEFAULT_THEME_ID } from './themes';

const base = THEMES[DEFAULT_THEME_ID];

/** @deprecated Use `useTheme().colors` so the value tracks the active theme. */
export const colors = {
  ...base.colors,
  /** Older name for `accent`. */
  aimYellow: base.colors.accent,
};

/** @deprecated Use `useTheme().fonts`. */
export const fonts = {
  ...base.fonts,
  uiFallback: Platform.select({
    ios: 'Helvetica',
    macos: 'Helvetica',
    windows: 'Segoe UI',
    default: 'System',
  }) as string,
};

/** @deprecated Use `useTheme().fontSizes`. */
export const fontSizes = base.fontSizes;

/** @deprecated Use `useTheme().metrics`. */
export const metrics = { ...base.metrics, borderWidth: 1 };

export const isTouch = Platform.OS === 'ios' || Platform.OS === 'android';
export const isDesktop = !isTouch;
